/**
 * Entrega ao SolidJS a instrumentacao de todo scope, antes que exista um.
 *
 * Importado PRIMEIRO pelo `main.tsx`, e essa ordem e a razao de ser um modulo:
 * o `@Observable` instala os acessores de uma classe na primeira vez que uma
 * instancia dela e construida, entao quem decide o que aqueles acessores fazem tem
 * de dizer antes disso.
 */
import { useSolidScopes } from 'wdc-cube-solid'

useSolidScopes()
